import { resolveComponent as r, openBlock as n, createBlock as o, resolveDynamicComponent as a, mergeProps as i, withCtx as s, renderSlot as l } from "vue";
import { getLinkKindModifier as d, LINK_KIND_MODIFIERS as p, LINK_VARIANTS as u } from "./link-constants.js";
import { _ as c } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const f = {
  compatConfig: { MODE: 3 },
  name: "DtLink",
  props: {
    /**
     * Applies the link variant styles
     * @values null, danger, warning, success, muted, mention
     */
    kind: {
      type: String,
      default: "",
      validator(t) {
        return u.includes(t);
      }
    },
    /**
     * Determines whether the link should have inverted styling
     * default is false.
     * @values true, false
     */
    inverted: {
      type: Boolean,
      default: !1
    },
    /**
     * URL for anchor link navigation. Renders as a native <a> element.
     */
    href: {
      type: String,
      default: null
    },
    /**
     * Vue Router destination. Renders as a <router-link>.
     * Takes precedence over href when both are provided.
     * @see https://router.vuejs.org/api/interfaces/RouterLinkProps.html#to
     */
    to: {
      type: [String, Object],
      default: null
    },
    /**
     * When true, navigation replaces the current history entry instead of pushing.
     * Only applies when `to` is provided.
     * @values true, false
     */
    replace: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      LINK_KIND_MODIFIERS: p
    };
  },
  computed: {
    computedTag() {
      return this.to ? r("RouterLink") : "a";
    },
    computedAttrs() {
      return this.to ? {
        to: this.to,
        replace: this.replace
      } : {
        href: this.href || "javascript:void(0)"
      };
    }
  },
  methods: {
    getLinkClasses() {
      return [
        "d-link",
        d(this.kind, this.inverted)
      ];
    }
  }
};
function m(t, h, k, _, g, e) {
  return n(), o(a(e.computedTag), i({
    class: e.getLinkClasses(),
    "data-qa": "dt-link"
  }, e.computedAttrs), {
    default: s(() => [
      l(t.$slots, "default")
    ]),
    _: 3
  }, 16, ["class"]);
}
const C = /* @__PURE__ */ c(f, [["render", m]]);
export {
  C as default
};
//# sourceMappingURL=link.js.map
